<template>
  <div class="mobile-repair-page">
    <div class="repair-header" v-show="!showConfirmStep">
      <van-button type="default" block @click="showAddressPopup = true"
        >文石维修地址</van-button
      >

      <van-popup v-model="showAddressPopup" position="bottom" round>
        <div class="address-popup">
          <div class="address-popup-title">文石维修地址</div>
          <div class="address-popup-content">
            <p>联系人：文石售后维修</p>
            <p>电话：13826127601</p>
            <p>地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）</p>
          </div>
          <van-button type="primary" block @click="copyAddress"
            >复制地址</van-button
          >
        </div>
      </van-popup>
    </div>

    <div class="repair-main" v-show="!showConfirmStep">
      <van-cell-group title="产品信息">
        <MobileStep1 :device="params.details[0]" ref="step1" />
        <MobileStep2
          :device="params.details[0]"
          :params="params"
          ref="step2"
          @saveData="saveCurrentData"
        />
      </van-cell-group>

      <van-cell-group title="寄修信息">
        <MobileStep3 :device="params.details[0]" :params="params" ref="step3" />
      </van-cell-group>

      <div class="fixed-bottom">
        <div class="privacy-checkbox">
          <van-checkbox v-model="privacyAgreed" shape="square">
            阅读并同意
            <span class="privacy-link" @click="showPrivacyDialog = true"
              >《隐私政策》</span
            >
          </van-checkbox>
        </div>
        <van-button type="primary" block @click="submitForm" class="orange"
          >提交</van-button
        >
      </div>
    </div>

    <PrivacyPolicyDialog
      :visible.sync="showPrivacyDialog"
      @agree="handlePrivacyAgree"
    />

    <MobileStep5
      v-if="showConfirmStep"
      :repairData="params"
      @back="showConfirmStep = false"
      @saveData="saveData"
    />

    <van-dialog
      v-model="showTips"
      :title="tipsTitle"
      :show-confirm-button="true"
      :show-cancel-button="false"
      confirm-button-text="我知道了"
      @confirm="closeTips"
    >
      <div v-html="tipsMsg"></div>
    </van-dialog>
  </div>
</template>

<script>
// 声明 wx 变量，解决 linter 错误
/* global wx */

import MobileStep1 from "./components/MobileStep1";
import MobileStep2 from "./components/MobileStep2";
import MobileStep3 from "./components/MobileStep3";
import MobileStep5 from "./components/MobileStep5";
import PrivacyPolicyDialog from "@/views/repair/components/PrivacyPolicyDialog.vue";
import { isMobileDevice } from "@/utils";
import { nextTick } from "vue";

export default {
  computed: {
    isInLand() {
      return process.env.VUE_APP_AREA === "inland";
    },
  },
  components: {
    MobileStep1,
    MobileStep2,
    MobileStep3,
    MobileStep5,
    PrivacyPolicyDialog,
  },
  data() {
    return {
      showAddressPopup: false,
      showConfirmStep: false,
      params: {
        attachs: [],
        tmpAddress: "",
        sendAddress: "",
        sendContact: "",
        receiveDeliveryInc: "",
        receiveDeliveryCode: "",
        sendPhone: "",
        phone: "",
        customer: "",
        email: "",
        zipCode: "",
        country: "",
        areaCode: {},
        area: [],
        details: [
          {
            model: "",
            desc: "",
            sn: "",
            purTime: "",
            powerOnPass: "",
            fittings: [],
            fittingsData: [],
            purchases: [],
          },
        ],
      },
      showTips: false,
      tipsTitle: "",
      tipsMsg: "",
      isMobile: isMobileDevice(),
      privacyAgreed: false,
      showPrivacyDialog: false,
    };
  },
  inject: ["scrollTo"],
  methods: {
    async getDetails() {
      let res = await this.$http.getRepairReqDetails({
        id: this.$route.query.id,
      });
      this.params.id = res.data.id;
      this.params.attachs = res.data.attachs || [];
      this.params.sendAddress = res.data.sendAddress;
      this.params.tmpAddress = res.data.tmpAddress;
      this.params.sendContact = res.data.sendContact;
      this.params.receiveDeliveryInc = res.data.receiveDeliveryInc;
      this.params.receiveDeliveryCode = res.data.receiveDeliveryCode;
      this.params.sendPhone = res.data.sendPhone;
      this.params.phone = res.data.phone;
      this.params.customer = res.data.customer;
      this.params.areaCode = res.data.areaCode;
      this.params.country = res.data.country || "";
      this.params.email = res.data.email || "";
      this.params.zipCode = res.data.zipCode || "";
      this.params.area = res.data.area.split("/");
      this.params.details[0].model = res.data.details[0].model;
      this.params.details[0].purchases = res.data.details[0].purchases || [];
      this.params.details[0].desc = res.data.details[0].desc;
      this.params.details[0].sn = res.data.details[0].sn;
      this.params.details[0].purTime = res.data.details[0].purTime;
      this.params.details[0].powerOnPass = res.data.details[0].powerOnPass;
      this.params.details[0].fittings = res.data.details[0].fittings || [];
    },

    submitForm() {
      // 验证隐私政策
      if (!this.privacyAgreed) {
        this.$toast("请先阅读并同意隐私政策");
        return;
      }

      // 表单验证
      if (!this.validateStep1()) {
        this.scrollToStep(1);
        return;
      }

      if (!this.validateStep2()) {
        this.scrollToStep(2);
        return;
      }

      if (!this.validateStep3()) {
        this.scrollToStep(3);
        return;
      }

      // 验证通过，显示确认步骤
      if (
        this.$refs.step3 &&
        typeof this.$refs.step3.setFittingsData === "function"
      ) {
        this.$refs.step3.setFittingsData();
      }
      this.showConfirmStep = true;
      this.scrollTo(0); // 滚动到页面顶部
    },

    scrollToStep(stepNumber) {
      const stepElement = document.querySelector(
        `.step-container:nth-child(${stepNumber})`
      );
      if (stepElement) {
        this.scrollTo(stepElement.offsetTop - 20);
      }
    },

    validateStep1() {
      // 验证步骤1：选择寄修设备
      if (!this.params.details[0].model) {
        this.$toast("请选择产品型号");
        return false;
      }
      return true;
    },

    validateStep2() {
      // 验证步骤2：填写故障信息
      if (!this.params.details[0].sn) {
        this.$toast("请输入序列号");
        return false;
      }

      if (!this.params.details[0].purTime) {
        this.$toast("请选择购买日期");
        return false;
      }

      // 判断是否需要上传购买凭证
      const purchaseDate = new Date(this.params.details[0].purTime);
      const currentDate = new Date();
      const daysDiff = Math.floor(
        (currentDate - purchaseDate) / (24 * 60 * 60 * 1000)
      );

      if (
        daysDiff <= 365 &&
        (!this.params.details[0].purchases ||
          this.params.details[0].purchases.length === 0)
      ) {
        this.$toast("请上传购买凭证");
        return false;
      }

      if (!this.params.details[0].desc) {
        this.$toast("请填写故障描述");
        return false;
      }

      if (!this.params.attachs || this.params.attachs.length === 0) {
        this.$toast("请上传附件");
        return false;
      }

      return true;
    },

    validateStep3() {
      // 验证步骤3：登记寄回部件
      if (
        !this.params.details[0].fittings ||
        this.params.details[0].fittings.length === 0
      ) {
        this.$toast("请选择寄回部件");
        return false;
      }

      if (!this.params.sendContact) {
        this.$toast("请输入收件人姓名");
        return false;
      }

      if (!this.params.sendPhone) {
        this.$toast("请输入收件人电话");
        return false;
      }

      this.params.sendPhone = this.params.sendPhone.replace(/\s+/g, "");

      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.params.sendPhone)) {
        this.$toast("请输入正确的手机号码");
        return false;
      }

      if (!this.params.area || this.params.area.length === 0) {
        this.$toast("请选择收件地区");
        return false;
      }

      if (!this.params.tmpAddress) {
        this.$toast("请输入详细地址");
        return false;
      }

      return true;
    },

    async saveData(status) {
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });

      try {
        // 处理fittingsData字段
        if (
          this.$refs.step3 &&
          typeof this.$refs.step3.setFittingsData === "function"
        ) {
          this.$refs.step3.setFittingsData();
        }

        delete this.params.details[0].fittingsData;
        for (let item of this.params.attachs) {
          if (item && item.url) {
            delete item.url;
          }
        }
        for (let item of this.params.details[0].purchases) {
          if (item && item.url) {
            delete item.url;
          }
        }
        this.params.status = status;

        this.params.sendAddress =
          this.params.area.join("") + this.params.tmpAddress;

        this.params.area = this.params.area.join("/");
        // delete this.params.tmpAddress
        if (this.params.areaCode?.node) delete this.params.areaCode.node;

        // 如果 receiveDeliveryInc 是对象，提取 value 属性
        if (
          this.params.receiveDeliveryInc &&
          typeof this.params.receiveDeliveryInc === "object" &&
          this.params.receiveDeliveryInc.value
        ) {
          this.params.receiveDeliveryInc = this.params.receiveDeliveryInc.value;
        }

        // 提交数据到服务器的代码
        if (this.$route.query.id) {
          await this.$http.updateRepairWithUser(this.params);
        } else {
          await this.$http.createRepairReq(this.params);
        }

        this.$toast.clear();
        this.$router.push({
          name: "RepairSuccess",
          query: { ...this.$route.query, submitStatus: this.params.status },
        });

        // 操作完成后，返回表单页面
        this.showConfirmStep = false;
        this.$toast.success("提交成功");
      } catch (error) {
        console.log(error);
        this.params.area = this.params.area.split("/");
        this.$toast.clear();
        this.$toast.fail("提交失败");
      }
    },

    handlePrivacyAgree() {
      this.privacyAgreed = true;
    },
    copyAddress() {
      let str = `联系人：文石售后维修\n电话：13826127601\n地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）`;
      const textarea = document.createElement("textarea");
      textarea.value = str;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      textarea.style.top = "0";
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);
      let successful = false;
      try {
        successful = document.execCommand("copy");
      } catch (err) {
        console.error("复制失败", err);
      }
      document.body.removeChild(textarea);
      if (successful) {
        this.$toast.success("已复制");
      } else {
        this.$toast.fail("复制失败，请手动复制");
      }
      this.showAddressPopup = false;
    },

    closeTips() {
      // 使用 try-catch 块来处理可能不存在的 wx 对象
      try {
        if (typeof wx !== "undefined" && wx.miniProgram) {
          wx.miniProgram.navigateBack();
        }
      } catch (error) {
        console.error("wx is not defined:", error);
      }

      if (!this.$route.query.t) {
        this.$router.push({ name: "SelfService" });
      }
    },

    async getEventNotif() {
      try {
        let res = await this.$http.getEventNotif({
          eventKey: "USER_ADD_REPAIR_REQ",
        });
        if (res.data.row) {
          this.tipsTitle = res.data.row.title;
          this.tipsMsg = res.data.row.message;
          this.showTips = true;
        } else {
          this.showTips = false;
        }
      } catch (error) {
        this.showTips = false;
        console.log(error);
      }
    },

    // 保存当前页面数据
    saveCurrentData() {
      const currentData = {
        params: { ...this.params },
        timestamp: Date.now(), // 添加时间戳，避免数据过期
      };
      localStorage.setItem("repairFormData", JSON.stringify(currentData));
    },

    // 恢复页面数据
    restoreCurrentData() {
      try {
        const savedData = localStorage.getItem("repairFormData");
        if (savedData) {
          const data = JSON.parse(savedData);

          // 检查数据是否过期（1小时内有效）
          if (Date.now() - data.timestamp < 60 * 60 * 1000) {
            this.params = { ...this.params, ...data.params };
            localStorage.removeItem("repairFormData");
          } else {
            localStorage.removeItem("repairFormData");
          }
        }
      } catch (error) {
        console.error("恢复页面数据失败:", error);
      }
    },

    // 检查是否有扫码结果返回
    checkScanResult() {
      const urlParams = new URLSearchParams(window.location.search);
      const scanResult = urlParams.get("scanResult");
      if (scanResult) this.params.details[0].sn = scanResult;
    },
  },
  async mounted() {
    this.getEventNotif();
    if (this.$route.query.id && this.$route.query.t) {
      // 小程序编辑寄修单调用
      this.$local.set("afterSaleToken", this.$route.query.t);
      this.$cookie.set("afterSaleToken", this.$route.query.t);
      await this.getDetails();
      nextTick(() => {
        this.$refs.step3.initLogistics();
      });
    } else if (!this.$route.query.id && this.$route.query.t) {
      // 小程序创建寄修单调用
      this.$local.remove("afterSaleToken");
      this.$cookie.remove("afterSaleToken");
      if (this.$route.query.p) this.params.sendPhone = this.$route.query.p;
      if (this.$route.query.n) this.params.sendContact = this.$route.query.n;
    } else if (this.$route.query.id && !this.$route.query.t) {
      // 网页编辑调用
      await this.getDetails();
    }

    if (window.performance.navigation.type !== 1) {
      this.$local.remove("tips");
    }

    // 显示使用须知弹窗
    if (this.$route.query.scanResult) {
      this.restoreCurrentData();
      this.checkScanResult();
    } else {
      if (
        !this.$local.get("tips") &&
        !(this.$route.query.id && this.$route.query.t)
      ) {
        this.$dialog
          .alert({
            title: "温馨提示",
            message:
              "如只是机器故障，只需寄出机器即可，数据线、保护套、电磁笔等配件无需寄回，避免回寄出现丢失，破损等意外情况，感谢您的理解。",
          })
          .then(() => {
            this.$local.set("tips", true);
          });
      }
    }
  },
  created() {
    // 检测是否是PC设备，如果是则重定向到PC端页面
    if (!this.isMobile && !this.$route.query.forceMobile) {
      this.$router.replace({
        name: "RepairReq",
        query: { ...this.$route.query },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.mobile-repair-page {
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 20px;
  width: 100%;

  .repair-header {
    .address-value {
      color: #1989fa;
    }
  }

  .address-popup {
    padding: 20px;

    .address-popup-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
      text-align: center;
    }

    .address-popup-content {
      margin-bottom: 20px;

      p {
        margin: 8px 0;
        font-size: 14px;
      }
    }
  }

  .repair-main {
    flex: 1;
    padding-bottom: 50px;

    .repair-title {
      padding: 20px 15px;
      background: #fff;
      border-bottom: 1px solid #eee;
      margin-bottom: 10px;

      .title-text {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 0;
      }
    }

    .step-container {
      margin-bottom: 10px;
      background: #fff;

      .step-title {
        padding: 15px;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;

        .step-number {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          background: #1989fa;
          color: #fff;
          border-radius: 50%;
          margin-right: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .step-text {
          font-size: 16px;
          font-weight: 500;
        }
      }

      .step-content {
        padding: 0;
      }
    }
  }

  .fixed-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 10px 15px 30px;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;

    .privacy-checkbox {
      text-align: center;
      font-size: 14px;
      margin-bottom: 10px;

      .privacy-link {
        color: #1989fa;
        text-decoration: underline;
      }
    }
  }
}

// 确保子组件内部样式不受影响
::v-deep .van-hairline--top-bottom::after {
  border-width: 0;
}

::v-deep .van-field__label {
  width: 6em;
}

::v-deep .van-dialog__header {
  font-weight: bold;
}
::v-deep .van-dialog__content {
  padding: 15px;
  font-size: 14px;
  line-height: 1.5;
}

.orange {
  background-color: #ce653e;
  border-color: #ce653e;
}
</style>
